module.exports = __webpack_public_path__ + "img/chrome.5518c035.png";